/* eslint-disable */
import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { Menu, MenuItem, useTheme } from '@mui/material';

import InformationModal from '../InformationModal';
import ForwardModal from '../ForwardMessageModal';
import ShowTicketOpen from '../ShowTicketOpenModal';
import DeleteMessageConfirmationModal from './deleteMessageConfirmationModal';

import { i18n } from '../../translate/i18n';
import api from '../../services/api';

import { ReplyMessageContext } from '../../context/ReplyingMessage/ReplyingMessageContext';
import { ForwardMessageContext } from '../../context/ForwarMessage/ForwardMessageContext';
import { EditMessageContext } from '../../context/EditingMessage/EditingMessageContext';
import { TicketsContext } from '../../context/Tickets/TicketsContext';
import toastError from '../../toasts/toastError';
import { AuthContext } from '../../context/Auth/AuthContext';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { getStyled } from './styles';

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  isGroup,
  queueId,
  whatsappId,
}) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const editingContext = useContext(EditMessageContext);
  const setEditingMessage = editingContext
    ? editingContext.setEditingMessage
    : null;
  const { setTabOpen } = useContext(TicketsContext);
  const navigate = useNavigate();
  const [isReactionBox, setIsReactionBox] = useState(false);

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState('');
  const [queueTicketOpen, setQueueTicketOpen] = useState('');
  const [
    acceptTicketWithouSelectQueueOpen,
    setAcceptTicketWithouSelectQueueOpen,
  ] = useState(false);

  const [ticketOpen, setTicketOpen] = useState(null);

  const [showTranscribedText, setShowTranscribedText] = useState(false);
  const [audioMessageTranscribeToText, setAudioMessageTranscribeToText] =
    useState('');

  useEffect(() => {
    if (menuOpen) {
      setIsReactionBox(false);
    }
  }, [menuOpen]);

  const {
    showSelectMessageCheckbox,
    setShowSelectMessageCheckbox,
    selectedMessages,
    forwardMessageModalOpen,
    setForwardMessageModalOpen,
  } = useContext(ForwardMessageContext);

  const handleSaveTicket = async (contactId) => {
    if (!contactId) return;

    try {
      const { data: ticket } = await api.post('/tickets', {
        contactId: contactId,
        userId: user?.id,
        status: 'open',
        queueId: queueId,
        whatsappId: whatsappId,
      });

      setTicketOpen(ticket);
      if (ticket.queueId === null) {
        setAcceptTicketWithouSelectQueueOpen(true);
      } else {
        setTabOpen('open');
        navigate(`/tickets/${ticket.uuid}`);
      }
    } catch (err) {
      const ticket = JSON.parse(err.response.data.error);

      if (ticket.userId !== user?.id) {
        setOpenAlert(true);
        setUserTicketOpen(ticket.user.name);
        setQueueTicketOpen(ticket.queue.name);
      } else {
        setOpenAlert(false);
        setUserTicketOpen('');
        setQueueTicketOpen('');

        setTabOpen(ticket.status);
        navigate(`/tickets/${ticket.uuid}`);
      }
    }
    handleClose();
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setOpenAlert(false);
    setUserTicketOpen('');
    setQueueTicketOpen('');
  };

  const handleSetShowSelectCheckbox = () => {
    setShowSelectMessageCheckbox(!showSelectMessageCheckbox);
    handleClose();
  };

  const handleEditMessage = async () => {
    setEditingMessage(message);
    handleClose();
  };

  const handleTranscriptionAudioToText = async () => {
    try {
      const audioUrl = String(message.mediaUrl);
      const match = audioUrl.match(/\/([^\/]+\.ogg)$/);
      const extractedPart = match ? match[1] : null;
      if (!extractedPart) {
        throw new Error('Formato de URL de áudio inesperado');
      }
      const response = await api.get(
        `/messages/transcribeAudio/${extractedPart}`,
      );
      const { data } = response;
      if (data && typeof data.transcribedText === 'string') {
        setAudioMessageTranscribeToText(data.transcribedText);
        setShowTranscribedText(true);
        handleClose();
      } else if (data && data.error) {
        throw new Error(data.error);
      } else {
        throw new Error('Dados de transcrição inválidos');
      }
    } catch (err) {
      toastError(err.message || 'Erro desconhecido');
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const isWithinFifteenMinutes = () => {
    const fifteenMinutesInMilliseconds = 15 * 60 * 1000;
    const currentTime = new Date();
    const messageTime = new Date(message.createdAt);

    return currentTime - messageTime <= fifteenMinutesInMilliseconds;
  };

  const handleOpenConfirmationModal = () => {
    setConfirmationOpen(true);
  };

  const handleSendReaction = async (emoji) => {
    try {
      await api.post(`/messages/${message.ticketId}/reaction`, {
        messageId: message.wid,
        reaction: emoji,
      });

      setIsReactionBox(false);
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenReactionBox = () => {
    setIsReactionBox(true);
  };

  const handleAddEmoji = (e) => {
    const emoji = e.native || e.colons;

    handleSendReaction(emoji);
  };

  return (
    <>
      <ShowTicketOpen
        isOpen={openAlert}
        handleClose={handleCloseAlert}
        user={userTicketOpen}
        queue={queueTicketOpen}
      />
      <DeleteMessageConfirmationModal
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        handleClose={handleClose}
        message={message}
      >
        {i18n.t('messageOptionsMenu.confirmationModal.message')}
      </DeleteMessageConfirmationModal>

      <InformationModal
        title={i18n.t('Transcrição de áudio')}
        open={showTranscribedText}
        onClose={setShowTranscribedText}
      >
        {audioMessageTranscribeToText}
      </InformationModal>

      <ForwardModal
        modalOpen={forwardMessageModalOpen}
        messages={selectedMessages}
        onClose={() => {
          setForwardMessageModalOpen(false);
          setShowSelectMessageCheckbox(false);
        }}
      />
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: message.fromMe ? 'left' : 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: message.fromMe ? 'right' : 'left',
        }}
        marginThreshold={0}
        getcontentanchorel={null}
        open={menuOpen && !isReactionBox}
        onClose={handleClose}
        keepMounted
        disableScrollLock
        transitionDuration={0}
        message={message}
        PaperProps={{
          sx: {
            backgroundColor:
              theme.palette.mode === 'light' ? '#EEE' : '#192734',
            color: theme.palette.mode === 'light' ? '#15202B' : '#FFF',
          },
        }}
      >
        {message.fromMe && (
          <MenuItem key='delete' onClick={handleOpenConfirmationModal}>
            {i18n.t('messageOptionsMenu.delete')}
          </MenuItem>
        )}
        {message.fromMe && isWithinFifteenMinutes() && (
          <MenuItem key='edit' onClick={handleEditMessage}>
            {i18n.t('messageOptionsMenu.edit')}
          </MenuItem>
        )}
        {message.mediaType === 'audio' && !message.fromMe && (
          <MenuItem key='transcribe' onClick={handleTranscriptionAudioToText}>
            {i18n.t('Transcrever áudio')}
          </MenuItem>
        )}
        {
          <MenuItem key='reply' onClick={hanldeReplyMessage}>
            {i18n.t('messageOptionsMenu.reply')}
          </MenuItem>
        }
        {
          <MenuItem key='forward' onClick={handleSetShowSelectCheckbox}>
            {i18n.t('messageOptionsMenu.forward')}
          </MenuItem>
        }
        {
          <MenuItem key='react' onClick={handleOpenReactionBox}>
            {i18n.t('messageOptionsMenu.react')}
          </MenuItem>
        }
        {!message.fromMe && isGroup && (
          <MenuItem
            key='talk'
            onClick={() => handleSaveTicket(message?.contact?.id)}
          >
            {i18n.t('messageOptionsMenu.talkTo')}
          </MenuItem>
        )}
      </Menu>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        marginThreshold={0}
        getcontentanchorel={null}
        open={menuOpen && isReactionBox}
        onClose={() => {
          setIsReactionBox(false);
          handleClose();
        }}
        keepMounted={false}
        disableScrollLock
        transitionDuration={0}
        PaperProps={{
          style: {
            width: 'auto',
            height: 'auto',
            overflow: 'hidden',
            borderRadius: 12,
            display: 'flex',
            flexDirection: 'column',
            padding: 0,
          },
        }}
        sx={classes.menuReaction}
      >
        <div style={classes.emojiBox}>
          <Picker
            data={data}
            perLine={10}
            theme='dark'
            showPreview={false}
            showSkinTones={true}
            onEmojiSelect={handleAddEmoji}
            autoFocus={true}
            emojiTooltip={false}
          />
        </div>
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
